export const LogoMark = ({ className = "h-10 w-8" }) => (
  <svg viewBox="0 0 40 48" fill="none" className={className} aria-hidden="true">
    <path
      d="M20 2.5 35.5 8.7v13.8c0 11.6-6.9 19.5-15.5 23-8.6-3.5-15.5-11.4-15.5-23V8.7L20 2.5Z"
      stroke="#B08D57"
      strokeWidth="2.2"
      fill="rgba(176,141,87,0.10)"
      strokeLinejoin="round"
    />
    <path
      d="M20 7.6 30.8 11.6v10.9c0 9-5.2 15.3-10.8 18.2-5.6-2.9-10.8-9.2-10.8-18.2V11.6L20 7.6Z"
      stroke="#B08D57"
      strokeOpacity="0.45"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path d="M20 15v20" stroke="#B08D57" strokeWidth="1.6" strokeLinecap="round" />
    <path
      d="M20 19.5c-2.4-.6-3.9-2.1-4.5-4.3 2.4.6 3.9 2.1 4.5 4.3Zm0 0c2.4-.6 3.9-2.1 4.5-4.3-2.4.6-3.9 2.1-4.5 4.3Z"
      fill="#B08D57"
    />
    <path
      d="M20 25c-2.4-.6-3.9-2.1-4.5-4.3 2.4.6 3.9 2.1 4.5 4.3Zm0 0c2.4-.6 3.9-2.1 4.5-4.3-2.4.6-3.9 2.1-4.5 4.3Z"
      fill="#B08D57"
      fillOpacity="0.8"
    />
    <path
      d="M20 30.5c-2.4-.6-3.9-2.1-4.5-4.3 2.4.6 3.9 2.1 4.5 4.3Zm0 0c2.4-.6 3.9-2.1 4.5-4.3-2.4.6-3.9 2.1-4.5 4.3Z"
      fill="#B08D57"
      fillOpacity="0.6"
    />
  </svg>
);
